import { c as _c } from "react/compiler-runtime";
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';
type PrV2ViewedCheckboxIndicatorProps = {
  isViewed: boolean;
  className?: string;
};

/** Shared checked/unchecked square used by file and group viewed toggles. */
export function PrV2ViewedCheckboxIndicator(t0) {
  const $ = _c(6);
  const {
    isViewed,
    className
  } = t0;
  const t1 = isViewed ? "border-zinc-300 bg-zinc-200 text-zinc-900" : "border-zinc-500 text-transparent";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("flex size-3.5 items-center justify-center rounded-[3px] border", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Check className="size-3" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <span aria-hidden="true" className={t2}>{t3}</span>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}